export const ImageUrl = `https://pentalab.tech/wp-content/uploads/2022/03/penta-logo2.png`;
export const PentaUrl = `https://pentalab.tech/wp-content/uploads/2022/03/rocket.png`;
export const ApiUrl = `https://gatewayapi.curbe.com.ec/api/v1`;
// export const ApiUrl = `https://devgatewayapi.curbe.com.ec/api/v1`;